<template>
    <div ref="editTextarea">
        <div  v-if="!editing">
            <span style="white-space: pre-line;" :class="customClass">{{ comment }}</span>
            <i ref="editBtn" class="ri-pencil-line cursor-pointer" v-if="editable"></i>
        </div>
        <template v-else>
            <b-row>
                <textarea class="form-control" v-model.trim="comment" :placeholder="$t('page.please-enter-content')"></textarea>
              </b-row>
        </template>
    </div>
</template>

<script>
export default {
emits:['complete'],
props: {
    // 接收文本域的值
    value:{
        type:String,
        default:''
    },
    editable: {
      type: Boolean,
      default: true,
    },
    customClass: {
      type: String,
      default: '',
    },
},     
data () {
    return {
        comment:'',
        editing: false,
    }
},
watch:{},
mounted(){
    if(this.value){
        this.comment = this.value  
    }
    document.addEventListener('click', this.clickMe);
},
beforeUnmount() {
    document.removeEventListener('click', this.clickMe);
},
methods:{
    startEditing() {
      this.editing = true;
    },
    clickMe(event) {
      const editBtnRef = this.$refs.editBtn
      if (editBtnRef) {
        if (editBtnRef.contains(event.target)) {
          this.startEditing()
          return;
        }
      }
      if (this.editing && !this.$refs.editTextarea.contains(event.target)) {
          this.editing = false
            this.saveChange()
      }
    },
    saveChange(){
        if (this.comment) {
            this.$emit('complete',this.comment)
        }
    }
}
}
</script>

<style lang="scss" scoped>
</style>